import { BaseModel } from "@models/base.model";

export class ProviderType extends BaseModel {
  Name: string = '';
  Description: string = '';
  DisplayName: string = '';
  EnumName: string = '';
  DisplayInList: boolean = true;
}
